import { getWeekStartByLocale } from 'weekstart';
import { startOfWeek as startOfWeekFNS } from 'date-fns';

export const startOfWeek = (date: Date | number) => {
  return startOfWeekFNS(date, {
    weekStartsOn: getWeekStartByLocale(navigator.language),
  });
};
